import ChevronRight from "../../../../../../public/icons/chevronRight.svg";
import styles from "./shCheckoutFooterButton.module.scss";
import ShButton from "../../../../../../components/button/shButton";
import React from "react";

export const ShCheckoutFooterButton = ({ disabled = false, className="col-12 mb-2", children, onClick = () => { } } ) => {

    return <ShButton className={className} variant={"dark"} disabled={disabled}
              onClick={onClick}>

        { children }
        <ChevronRight className={styles.svgRight + " svg-light"} />

    </ShButton>

};
